const colors = {
    coreBlue: "#3C91E6",
    coreGreen: "#7FB33A",
    coreRed: "#ED1C3A",
    darkBlue: "#4276AA",
    navy: "#485E74",
    darkRed: "#A40C22",
    paleRed: "#FEEbEE",
    paleBlue: "#DAECFE",
    darkGrey: "#484847",
    midGrey1: "#636363",
    midGrey2: "#707070",
    midGrey3: "#808080",
    grey: "#979393",
    paleGrey: "#CCC",
    lightGrey: "#EDEDED",
    white: "#FFF",
    black: "#000",
    error1: '#FEEBEE',
    error2: '#ED1C3A',
    error3: '#A40C22',
    warning1: '#F1E6E0',
    warning2: '#EE824C',
    warning3: '#CC5013',
    info1: '#F4F9FE',
    info2: '#60A7EF',
    info3: '#1667B7',
};

const overrides = {
    UserCard: {
        AvatarContainer: {
            background: colors.white,
        },
        AvailabilityContainer: {
            borderColor: colors.white
        }
    },

    UserActivityControls: {
        Item: {
            color: colors.black,
            lightHover: false
        },
        Items: {
            background: colors.white,
        },
        Divider: {
            background: colors.darkGrey,
        }
    },

    // LoginView: {
    //     Container: {
    //         background: colors.base2,
    //         color: colors.lightTextColor
    //     },
    //     LoginButton: {
    //         background: colors.defaultButtonColor,
    //         color: colors.lightTextColor,
    //     },
    //     Logo: {
    //         color: colors.base11
    //     }
    // },

    // RuntimeLoginView: {
    //     Container: {
    //         background: colors.base2,
    //         color: colors.lightTextColor
    //     },
    //     LoginButton: {
    //         background: colors.defaultButtonColor,
    //         lightHover: true
    //     }
    // },

    AgentDesktopView: {
        Panel1: {
            background: colors.darkGrey,
            borderRadius: '4px',
            border: `1px solid ${colors.grey}`
        },
        Panel2: {
            background: "rgba(0,0,0,0)"
        },
        ContentSplitter: {
            background: colors.midGrey3,
            borderColor: colors.midGrey3,
            color: colors.midGrey3,
            width: '10px'
        }
    },

    MainHeader: {
        Container: {
            background: colors.white,
            color: colors.black,
            borderColor: colors.white
        },
        Button: {
            color: colors.black,
            lightHover: false
        }
    },

    SideNav: {
        Container: {
            background: colors.darkGrey,
            borderColor: colors.darkGrey
        },
        Button: {
            color: colors.lightGrey,
            // background: lightTheme ? colors.base8 : colors.base3,
            lightHover: false
        },
        Icon: {
            color: colors.lightGrey
        },
    },

    TaskDetailsPanel: {
        Container: {
            background: colors.darkGrey,
            color: colors.white
        },
        // IconContainer: {
        //     color: colors.base10
        // },
        SecondLine: {
            color: colors.white
        }
    },

    // IncomingTaskCanvas: {
    //     AcceptTaskButton: {
    //         color: colors.acceptTextColor,
    //         background: colors.acceptColor
    //     },
    //     RejectTaskButton: {
    //         color: colors.declineTextColor,
    //         background: colors.declineColor
    //     }
    // },

    TaskInfoPanel: {
        Container: {
            color: colors.white,
            padding: '0'
        }
    },

    // CallCanvas: {
    //     Button: {
    //         background: colors.base3,
    //         color: colors.base11
    //     },
    //     HangUpButton: {
    //         background: colors.declineColor,
    //         color: colors.declineTextColor
    //     },
    // },

    TaskCanvas: {
        Container: {
            background: colors.darkGrey,
            border: 'none',
            padding: '0'
        }
    },

    TaskCanvasHeader: {
        Container: {
            background: colors.darkGrey,
            color: colors.white,
            padding: '20px 20px 0 20px',
        },
        // WrapupTaskButton: {
        //     background: colors.declineColor,
        //     color: colors.declineTextColor,
        // },
        // EndTaskButton: {
        //     background: colors.completeTaskColor,
        //     color: colors.declineTextColor,
        // }
    },

    TaskList: {
        Container: {
            background: colors.darkGrey
        },
        Filter: {
            Container: {
                background: colors.darkGrey,
                borderColor: colors.grey,
                padding: '10px'
            },
            EntryButton: {
                color: colors.white
            },
            Menu: {
                Item: {
                    color: colors.white,
                    lightHover: false
                },
                Items: {
                    background: colors.darkGrey
                }
            }
        },
        Item: {
            Container: {
                color: colors.white,
                border: `solid 1px ${colors.grey}`,
                margin: '10px',
                background: colors.midGrey1,
                borderRadius: '4px',
                lightHover: false
            },
            Icon: {
                color: colors.white
            },
            SelectedContainer: {
                background: colors.navy,
                color: colors.white,
                borderColor: colors.darkBlue,
                lightHover: false
            },
            // Buttons: {
            //     DefaultButton: {
            //         color: colors.base11,
            //         background: colors.base3,
            //         // lightHover: !lightTheme
            //     },
            //     AcceptButton: {
            //         color: colors.acceptTextColor,
            //         background: colors.acceptColor
            //     },
            //     RejectButton: {
            //         color: colors.declineTextColor,
            //         background: colors.declineColor
            //     }
            // }
        },
    },

    // TaskCard: {
    //     Container: {
    //         Default: {
    //             borderColor: colors.grey,
    //             lightHover: false
    //         },
    //         Selected: {
    //             borderColor: colors.grey
    //         },
    //         Hover: {
    //             borderColor: colors.darkBlue
    //         }
    //     },
    //     IconArea: {
    //         Default: {
    //             color: colors.white
    //         },
    //     },
    //     ContentArea: {
    //         Default: {
    //             color: colors.white,
    //             backgroundColor: colors.base1
    //         },
    //         Inactive: {
    //             color: colors.white,
    //             backgroundColor: colors.darkGrey
    //         }
    //     }
    // },

    // TaskCardPlaceholder: {
    //     borderColor: colors.base4
    // },

    NoTasksCanvas: {
        Container: {
            color: colors.white,
            background: colors.darkGrey
        },
        Hint: {
            color: colors.lightGrey
        },
    },

    CRMContainer: {
        Container: {
            background: "rgba(0,0,0,0)",
            border: "none",
            overflow: "hidden",
            flex: '1 1 auto',
            marginLeft: '10px'
        }
    },

    // Supervisor: {
    //     Container: {
    //         background: colors.base1
    //     },
    //     TaskCanvas: {
    //         HeaderButton: {
    //             color: colors.base11,
    //             background: colors.base3,
    //             lightHover: !lightTheme
    //         },
    //         Container: {
    //             borderColor: colors.base4
    //         },
    //         MonitorActiveButton: {
    //             background: colors.flexBlueColor,
    //             color: colors.lightTextColor
    //         },
    //         Button: {
    //             background: colors.base3,
    //             color: colors.base11
    //         },
    //     },
    //     WorkerCanvas: {
    //         Container: {
    //             background: colors.base2,
    //             borderColor: colors.base4,
    //             color: textColor
    //         },
    //         Header: {
    //             borderColor: colors.base4,
    //             color: textColor
    //         }
    //     }
    // },

    // WorkerDirectory: {
    //     Container: {
    //         boxShadow: "-2px 0 10px 0 rgba(0, 0, 0, 0.2)",
    //         background: colors.base2,
    //         color: textColor
    //     },
    //     Header: {
    //         Button: {
    //             color: colors.base11,
    //             background: colors.base3,
    //             lightHover: !lightTheme
    //         },
    //         Container: {
    //         },
    //     },
    //     ItemsContainer: {
    //         borderColor: colors.base4,
    //     },
    //     Item: {
    //         borderColor: colors.base4,
    //         background: colors.base2,
    //         lightHover: !lightTheme
    //     },
    //     ItemActionButton: {
    //         color: colors.base11,
    //         background: colors.base3,
    //         lightHover: !lightTheme
    //     },
    //     QueueItem: {
    //         Avatar: {
    //             background: colors.base3
    //         }
    //     }
    // },

    // WorkerSkills: {
    //     SaveButton: {
    //         background: colors.flexBlueColor,
    //         color: colors.lightTextColor
    //     },
    //     CancelButton: {
    //         background: colors.disabledColor,
    //         color: colors.darkTextColor
    //     },
    //     DeleteButton: {
    //         borderColor: colors.base4,
    //         lightHover: !lightTheme
    //     },
    // },

    // LoadingView: {
    //     Container: {
    //         background: colors.base2,
    //         color: colors.base6
    //     }
    // },
    // ParticipantsCanvas: {
    //  ParticipantCanvas: {
    //      Container: {
    //          color: textColor
    //      },
    //      Avatar: {
    //          background: colors.flexBlueColor,
    //          color: colors.lightTextColor,
    //          borderColor: colors.base5
    //      },
    //      StateHover: {
    //          background: colors.buttonHoverColor,
    //          color: colors.lightTextColor
    //      },
    //      ConnectingAnimation: {
    //          color: colors.lightTextColor
    //      },
    //      Button: {
    //          background: colors.base3,
    //          color: colors.base11
    //      },
    //      HangUpButton: {
    //          background: colors.declineColor,
    //          color: colors.declineTextColor
    //      }
    //  },
    //  Notification: {
    //      Container: {
    //          //background: colors.holdColor,
    //          //color: lightTheme ? colors.base1 : colors.base11
    //      }
    //  }
    // }
};

export default {
    baseName: "GreyDark",
    colors: colors,
    overrides: overrides,
    light: false
}